import { Paper, Stack, Typography, Box } from '@mui/material';

type Props = {
  title: string;
  value: string;
  subtitle?: string;
};

export default function KpiCard({ title, value, subtitle }: Props) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        bgcolor: 'rgba(255,255,255,0.06)',
        border: '1px solid rgba(255,255,255,0.10)',
      }}
    >
      <Stack spacing={0.8}>
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          {title}
        </Typography>

        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: -0.5 }}>
            {value}
          </Typography>
        </Box>

        {subtitle ? (
          <Typography variant="caption" sx={{ opacity: 0.75 }}>
            {subtitle}
          </Typography>
        ) : null}
      </Stack>
    </Paper>
  );
}